module.exports = __webpack_public_path__ + "img/arrow-download.5adfb5b9.svg";